<template lang="pug">
el-dialog(:visible.sync="visible" @close="closeDialog" append-to-body width="790px" :close-on-click-modal="false")
  .header_title(slot="title" v-if="value.guid") {{opTypeStr}}{{typeStr}}
  .main(v-if="!haveSaved")
    .order_message
      p(style="line-height: 1; height: 40px;padding-top: 13px;")
        span 订单编号：
        span.content {{value.orderCode}}
        span 认证主体：
        span.content {{adUser.customerName}}
      p(v-if="value.valuationType == 3")
        span 起始日期：
        span.content(style="border-right: none;") {{value.startDate}}(共{{value.validDays}}天)
      p(v-else style="line-height: 40px")
        span 投放日期：
        span.content(style="border-right: none;") {{value.startDate}} ~ {{value.endDate}}(共{{value.validDays}}天)
      //- screenArea == 1 是 小屏  不展示投放时段
      p(style="border-bottom: none;" v-if="!isUrl && !screenAreaIs1(orderData)")
        span 投放时段：
        span.content.time_slot(v-html="timeSlotNames")
    .tips(v-if="!isWifi")
      .label-input
        span.must 广告名称
          span *
        el-input(placeholder="请输入" maxlength="35" v-model="advert.name")
          i.iconfont.icon-biaodan-tianxie(slot="suffix")
      .time_tip(v-if="!isUrl") 单次曝光{{value.contentTime}}秒
      .clear
      .caption(v-if="!isWifi && !isH5RealTime && !screenAreaIs1(value)")
        el-input(
          maxlength="50" show-word-limit placeholder="请输入广告字幕，最多不超过50个字符"
          v-model="advert.subtitle")
          template(slot="prepend") 广告字幕

    .order_main(v-if="!isWifi")
      .box_ctn
        Upload_box(v-for="(item, i) in materialSizeList" :key="i" :orderData="value" :item="item" v-model="resources[i]" :contentTime="value.contentTime")

    .order_message.wifi(v-if="isWifi")
      p
        span.left 广告名称
        span.content
          el-input(placeholder="请输入广告名称，限30个字以内" v-model="wifiObj.name")
            i.iconfont.icon-biaodan-tianxie(slot="suffix")
      p
        span.left 广告URL
        span.content
          el-input(placeholder="请输入WiFi广告的URL地址(以http或https开头)" v-model="wifiObj.url")
            i.iconfont.icon-biaodan-tianxie(slot="suffix")

  .footer(slot="footer" v-if="!haveSaved")
    button(class="close_button" @click="saveVideoInfo") 保存
    button(class="close_button" @click="cancel") 取消
  .main(v-if="haveSaved")
    .success_box
      img.success_img(src="../assets/upload_success.png")
      p(v-if="value.advContentDto && value.advContentDto.customerGuid")
        | 素材{{changeStr}}更新成功！
      p(v-else) 素材已经上传完成啦！
        span(v-if="needCheck") 广告需要一定的审核时间哦～
  .footer(slot="footer" v-if="haveSaved")
    button(class="close_button" @click="callback") 关闭
</template>

<script>
// import { nanoid } from 'nanoidUtil'
import NormalSelect from './NormalSelect'
import Upload_box from './UploadVideo_upbox'
import { addOrderMaterial } from "../utils/api"

export default {
  name: "UploadVideo",
  components: { NormalSelect, Upload_box },
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      advert: { name: '', subtitle: '' },
      videoData: [{ screenType: 0 }, { screenType: 1 }], // 临时中间转换数组
      videoInfo: [{}, {}],
      readDialog: false,
      haveReaded: false,
      haveSaved: false,
      isFetching: false,
      needCheck: false,
      timeSlotNames: '',
      loading: null,

      resources: [], // 最终上传的结果
      materialSizeList: [], // 需要上传的素材列表
      orderData: {},

      wifiObj: {}
    }
  },
  computed: {
    changeStr() {
      return ''
    },
    visible: {
      get() {
        return this.value.showUpload
      },
      set() {
        this.$emit('input', {})
      }
    },
    adUser() { return this.$store.state.customer.userInfo },
    customer() { return this.$store.state.customer.customerInfo },
    isSmallSn() {
      return this.orderData.screenArea == 1
    },
    screenAreaIs1() {
      return item => {
        return !item || !item.hasOwnProperty('screenArea') || item.screenArea == 1
      }
    },
    isWifi() {
      return this.value.screenArea && this.value.screenArea == 3
    },
    isH5RealTime() {
      return this.value.screenArea && this.value.screenArea == 4
    },
    isUrl() { // 是否是需要展示上传url
      return this.isWifi || this.isH5RealTime;
    },
    opTypeStr() {
      return Number(this.value.execStatus) > 0 ? '更换' : '上传'
    },
    typeStr() {
      return this.isUrl ? 'URL' : '素材';
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.setOldVideo()
      } else {
        this.videoData = [{ screenType: 0 }, { screenType: 1 }]
        this.videoInfo = [{}, {}]
      }
    },
    videoData: {
      deep: true,
      handler(v) {
        this.videoInfo = v
      }
    }
  },
  methods: {
    cancel() {
      this.closeDialog()
    },
    async getMaterialType() {
      let res = await this.fetch('/dsp/web/order/v2/getOrderMaterialLimit', { orderGuid: this.value.guid }, 'get')
      if (res && res.code == 0 && res.data) return res.data.materialSizeList || []
      else return []
    },
    closeDialog() {
      this.materialSizeList = []
      this.resources = []
      this.wifiObj = {}
      this.advert.name = ''
      this.advert.subtitle = ''
      this.$emit('input', {})
    },
    async getOldResource(item) {
      let load = this.$loading()
      let res = await this.fetch('/dsp/content/v2/queryContentByOrder?orderGuid=' + item.guid, '', 'get')
      load.close()
      if (res && res.code == this.successCode) return res.data[0] || {}
      else return {}
    },
    handleUpbox(oldList, selectList) { // 新订单 getOldResource 可能是空数组 这时渲染上传框 从 getMaterialType 中的数据去取
      if (oldList.length) { // 更新素材
        this.materialSizeList = oldList.map((el, i) => {
          const uploadModes = selectList.filter(slt => slt.screenType == el.screenType)[0] || {}
          // 当前素材的上传方式下拉选项数据, 2023-10-19:素材上传方式移除【H5素材】
          el.materialSourceTypeList = (uploadModes.materialSourceTypeList || []).filter(s => s.code !== '5')
          // old数据中可能不存在 materialTypeName 素材类型名称
          el.materialSizeName = (uploadModes || {}).materialSizeName || el.screenTypeName || ''
          el.materialTypeName = el.materialTypeName || (uploadModes || {}).materialTypeName
          return el
        })
      } else { // 首次上传素材
        // 2023-10-19 素材上传方式移除【H5素材】
        this.materialSizeList = selectList.map(e => {
          const sourceTypes = (e.materialSourceTypeList || []).filter(s => s.code !== '5')
          return {
            ...e,
            materialSourceTypeList: sourceTypes
          }
        })
      }
    },
    async setOldVideo() {
      this.haveSaved = false

      // 获取素材信息
      let oldData = await this.getOldResource(this.value)
      let oldList = oldData.materialInfoList || []
      let selectList = await this.getMaterialType()
      this.handleUpbox(oldList, selectList)
      this.value.advContentDto = oldData

      if (oldData.customerGuid) {
        if (oldList.length) {
          if (this.isWifi) {
            let mateZero = oldList[0] || {}
            this.wifiObj = {
              name: oldData.contentName, url: mateZero.materialContent
            }
            return
          }
          this.videoInfo = oldList.map(
            el => ({
              reourceNo: el.materialCode,
              reourceAddress: el.materialContent,
              resourceName: el.materialName,
              contentSize: el.materialSize,
              typeCode: el.materialType,
              md5: el.md5,
              screenType: el.screenType,
              narrowImage: el.narrowImageUrl,
              videoJson: el.videoJson
            })
          )
        }
        this.haveReaded = true
      } else {
        this.haveReaded = false
      }
      this.advert.name = oldData.contentName || ''
      this.advert.subtitle = oldData.subtitle || ''
    },
    assertResources() {
      let ok = true, idx = -1, msg = '';
      for (let i = 0; i < this.materialSizeList.length; i++) {
        let curResource = this.resources[i]
        if (!curResource) {
          ok = false;
          idx = i;
          // msg = `请上传第${idx + 1}个素材或选择H5素材`
          msg = `请上传素材`
          break;
        }
        if (curResource.reourceAddress) curResource.materialContent = curResource.reourceAddress
        if (!curResource.materialContent || curResource.materialContent.trim() == '') {
          ok = false;
          idx = i;
          // msg = `请上传第${idx + 1}个${curResource.materialSizeName || ''}${curResource.materialType == 1 ? '视频' : '图片'}素材或选择H5素材`
          // msg = `请上传第${idx + 1}个素材或选择H5素材`
          msg = `请上传素材`
          break;
        } else {
          if (curResource.materialType == 5) {
            if (!/(http|https):\/\/([\w.]+\/?)\S*/.test(curResource.materialContent.trim())) {
              ok = false;
              idx = i;
              msg = 'H5素材URL格式不正确'
              break;
            }
          }
        }
      }
      return { ok, msg }
    },
    async addOrUpdateUrl() {
      let param = {
        contentGuid: this.value.advContentDto.guid,
        contentName: this.wifiObj.name,
        materialInfoList: [{
          materialContent: this.wifiObj.url, materialType: 4, screenType: 3
        }],
        orderGuid: this.value.guid
      }

      this.isFetching = true
      let response = await addOrderMaterial(param)
      if (response.code === 0) {
        this.$emit('upDone')
        this.$emit('input', {})
      } else {
        this.messageTip(response && response.msg || '操作失败，请稍后再试', 2)
      }
      setTimeout(() => {
        this.isFetching = false
      }, 100)
    },
    testName(name) {
      name = (name || '').trim()
      if (!name) return this.messageTip('请输入广告名称后再保存～', 2)
      let nameMaxL = 35
      if (name.length > nameMaxL) return this.messageTip('广告名称须' + nameMaxL + '个字符以内', 2)
      if (/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g.test(name)) {
        return this.messageTip('广告名称不能包含表情~', 2)
      }
      return true
    },
    async saveVideoInfo() {
      if (this.isFetching) return

      if (this.isWifi) {
        let { name, url } = this.wifiObj
        if (!this.testName(name)) return
        if (!url || url.trim() == '') return this.messageTip('请输入URL地址后再保存～', 2)
        let turl = url.toLowerCase().replace(/\s*/g, '')
        if (!turl.startsWith('http://') && !turl.startsWith('https://')) return this.messageTip('URL地址格式不正确', 2)
        await this.addOrUpdateUrl()
        return
      }

      let adName = this.advert.name
      if (!this.testName(adName)) return

      // 素材判断
      let assert = this.assertResources()
      if (!assert.ok) return this.messageTip(assert.msg, 2)

      let advContentDto = this.value.advContentDto
      let oldMaterialInfoList = advContentDto.materialInfoList
      let getOldGuid = el => { // 如果更新素材没有变化传原来的guid
        let type = el.screenType
        if (oldMaterialInfoList && oldMaterialInfoList.length > 0) {
          let typeData = oldMaterialInfoList.filter(el => el.screenType == type)[0]
          if (typeData && typeData.materialContent == el.reourceAddress) return typeData.guid
          else return ''
          // return typeData ? typeData.guid : null
        }
        return ''
      }
      let param = {
        contentGuid: this.value.advContentDto.guid,
        contentName: adName.trim(),
        subtitle: !this.advert.subtitle || this.advert.subtitle.trim() === '' ? '' : this.advert.subtitle.trim(),
        materialInfoList: this.resources.map(el => {
          if (el.isUrl) {
            return { materialDuration: this.value.contentTime, ...el }
          }
          let data = {
            materialCode: el.materialCode || el.reourceNo,
            // 20220817: 上传素材后保存素材接口【素材编号】字段需使用唯一标识符否则报错（暂不改）
            // materialCode: nanoid(),
            materialContent: el.reourceAddress,
            materialName: el.resourceName,
            materialSize: el.contentSize,
            materialType: el.typeCode,
            md5: el.md5,
            narrowImageUrl: el.narrowImage || el.reourceAddress,
            videoJson: el.videoJson,
            screenType: el.screenType,
            materialDuration: this.value.contentTime,
            guid: getOldGuid(el)
          }
          return data
        }),
        orderGuid: this.value.guid,
      }

      this.isFetching = true
      let response = await addOrderMaterial(param)
      if (response.code === 0) {
        if (this.value.advContentDto.customerGuid) {
          let getVideoInfo = this.value.advContentDto.materialInfoList && this.value.advContentDto.materialInfoList[0]
          this.needCheck = !(getVideoInfo && getVideoInfo.materialContent === this.videoInfo.reourceAddress)
        } else { this.needCheck = true }

        if (!this.isSmallSn) {
          if (param.materialInfoList.filter(el => el.materialType == 1).length > 0) { // 存在更新视频素材
            this.messageTip('系统已将您的视频转换为标准码率，请再次预览视频', 1)
          }
        }

        this.haveSaved = true
        this.$emit('upDone')
      } else {
        this.messageTip(response && response.msg || '操作失败，请稍后再试', 2)
      }
      setTimeout(() => {
        this.isFetching = false
      }, 100)

      if (this.$route.path === '/orderVideo') {
        if (response && response.code === 0) tzx_czcPush('order_video', 'upSuccess')
        else tzx_czcPush('order_video', 'upFail')
      } else if (this.$route.path === '/orderList') {
        if (response && response.code === 0) tzx_czcPush('order_list', 'upSuccess')
        else tzx_czcPush('order_list', 'upFail')
      }
    },
    callback() {
      this.$emit('input', {})
      this.$emit('callback')
    }
  }
}
</script>

<style lang="sass">
.upload_pop
    padding: 0
    .avc
        .avc_title
            height: 40px
            line-height: 40px
            font-weight: 400
            color: #282729
            background-color: #F5F5F5
            font-size: 14px
            margin-bottom: 25px
            text-align: center
        .img
            width: 350px
            height: 105px
            margin-bottom: 15px
</style>
<style lang="sass" scoped>
.time_slot
    display: inline-block
    width: 450px
    vertical-align: top
    line-height: 1.5
    margin-top: 10px
    margin-bottom: 10px
.label-input
    float: left
    width: 50%
    padding: 0 15px
    border-right: 1px solid #E9E9E9
    .must
        line-height: 1.5
        display: inline-block
        padding-right: 15px
        border-right: 1px solid #E9E9E9
        color: #999
        position: relative
        span
            position: absolute
            top: 2px
            left: -5px
            color: #FF3973
    ::v-deep .el-input
        width: 270px
        input
            border: none
            color: #282729
        .icon-biaodan-tianxie
            position: relative
            top: 10px
.header_title
    text-align: center
    font-size: 18px
    line-height: 24px
.main
    max-height: 580px
    color: #282729
    overflow: hidden
    .order_message
        padding: 0 10px
        background: #fff
        font-size: 12px
        color: #999
        line-height: 34px
        border: 1px solid #E9E9E9
        &.wifi
            background: #F5F5F5
            margin-top: 20px
            > p
                margin: 10px 0
                padding: 0 20px
                border-bottom: none
                color: #282729
                .content
                    width: calc(100% - 80px)
                ::v-deep .el-input
                    width: 100%
                    input
                        border: none
                        color: #999
                .left
                    display: inline-block
                    padding-right: 20px
                    line-height: 1
                    border-right: 1px solid #E9E9E9
        > p
            border-bottom: 1px solid #E9E9E9
            background: #fff
            padding: 0 10px
            &:last-child
                border-bottom: none
        .content
            display: inline-block
            padding-right: 20px
            margin-right: 20px
            border-right: 1px solid #D4D4D4
            color: #282729
            &:last-child
                border-right: none
                margin-right: 0
                padding-right: 0
    .tips
        width: 100%
        margin-top: 10px
        overflow: hidden
        border: 1px solid #E9E9E9
        .time_tip
            float: right
            width: 50%
            line-height: 40px
            background: #FFEBF1
            text-align: center
            font-weight: bold
        .caption
            border-top: 1px solid #e9e9e9
            ::v-deep .el-input
                input
                    border: none
                    color: #282729
                    padding: 0 45px 0 15px
                .el-input-group__prepend
                    background: #fff
                    border: none
                    color: #999
                    padding: 0 15px
                    height: 20px
                    line-height: 20px
                    position: relative
                    &:after
                        content: ' '
                        position: absolute
                        right: -1px
                        top: 10px
                        width: 1px
                        height: 20px
                        background: #e9e9e9

    .order_main
        background: #F5F5F5
        padding: 10px 0
        border: 1px solid #e9e9e9
        border-top: none
        display: flow-root
        max-height: 380px
        overflow: auto
        text-align: center
        .box_ctn
            margin: 0 auto
            width: 728px
            overflow: hidden
    .success_box
        text-align: center
        margin: 150px 0 144px
        img
            width: 185px
        p
            margin-top: 20px
            font-size: 16px
.footer
    padding: 15px 0
    border-top: 1px solid #E9E9E9
    text-align: center
    .close_button
        outline: 0
        width: 120px
        height: 30px
        background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%)
        border-radius: 4px
        border: none
        cursor: pointer
        color: #FFF
        & + .close_button
            margin-left: 20px
        &:last-child
            background: #FFF
            color: #282729
            border: 1px solid #D4D4D4
::v-deep .el-dialog
    border-radius: 8px
    margin-top: 10vh !important
    .el-dialog__header
        padding: 12px 0
        border-bottom: 1px solid #E9E9E9
    .el-dialog__headerbtn
        top: 17px
        right: 17px
        font-weight: 600
        color: #282729
    .el-dialog__body
        padding: 20px
    .el-dialog__footer
        padding: 0
.upload_title
    padding: 0 10px
    border-bottom: 1px solid #E9E9E9
    display: flow-root
    .left
        float: left
        .img
            float: left
            width: 16px
            height: 16px
            margin-top: 10px
        .title
            font-size: 14px
            font-weight: 400
            color: #282729
            line-height: 40px
            margin: 0 10px 0 5px
    .right
        cursor: pointer
        color: #999
        float: right
        .bestpx
            font-size: 12px
            font-weight: 400
            line-height: 40px
        i
            margin: 5px 0 0 5px
</style>
